import SeoHelper from '../helpers/SeoHelper/SeoHelper'
import {Box, Container, Flex, GridItem} from '@chakra-ui/react'
import {Page} from '../_app/components'
import {useRouter} from 'next/router'
import BreakpointsHelper from '../helpers/BreakpointsHelper/BreakpointsHelper'
import ImageCms from '../_app/components/Content/ImageCms'

const LePrive = () => {
    const history = useRouter()
    const { locale } = history
    const style: any = {
        paragraph: {
            color: '#690e18',
            fontSize: '20px',
            fontWeight: '700',
            marginBottom: '20px',
            textAlign: 'left',
            maxWidth: '520px',
            margin: '0 auto',
            zIndex: 5,
        },
        paragraphRight: {
            color: '#690e18',
            fontSize: '18px',
            fontWeight: '700',
            textAlign: 'right',
            marginBottom: '20px',
            maxWidth: '520px',
            margin: '0 auto',
            zIndex: 5,
        },
        paragraphRightJustify: {
            color: '#690e18',
            fontSize: '18px',
            fontWeight: '700',
            textAlign: 'justify',
            marginBottom: '20px',
            maxWidth: '520px',
            margin: '0 auto',
            zIndex: 5,
        },
        heading: {
            color: '#690e18',
            fontSize: '24px',
            fontWeight: '700',
            textAlign: 'center',
            margin: '0 auto',
            zIndex: 5,
        },
        button: {
            padding: '20px 50px',
            borderRadius: '50px',
            cursor: 'pointer',
            color: '#690e18',
            fontSize: '22px',
            fontWeight: '600',
            border: '1px solid #690e18',
            maxWidth: '500px',
            margin: '30px auto',
            transition: '.3s all ease',
            '&:hover': {
                transition: '.3s all ease',
                color: '#ffffff',
                backgroundColor: '#690e18',
                border: '1px solid #690e18'
            }
        },
        box: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            position: 'relative',
        },
        img: {
            width: '100%',
            objectFit: 'cover',
            maxWidth: '100%',
        },
        imgDown: {
            width: '100%',
            maxWidth: '100%',
            marginBottom: '30px',
        },
        imgRightAbsolute: {
            position: 'absolute',
            transform: 'rotate(405deg) scale(0.7)',
            right: '-200px',
            top: '-140px',
        },
        imgLeftAbsolute: {
            position: 'absolute',
            transform: 'rotate(315deg) scale(0.7)',
            left: '-200px',
            top: '0',
        },
        imgLeftAbsoluteBottom: {
            position: 'absolute',
            transform: 'rotate(315deg) scale(0.7)',
            right: '-220px',
            bottom: '-100px',
        },
        grid: {
            display: 'flex',
            flexDirection: BreakpointsHelper.isMobile() ? 'column': 'row',
            gap: '8px',
            overflow: 'hidden',
            flexWrap: 'wrap',
            '> div': {
                flex: 1,
            }
        },
        gridNoGap: {
            display: 'flex',
            flexDirection: BreakpointsHelper.isMobile() ? 'column': 'row',
            overflow: 'hidden',
            flexWrap: 'wrap',
            maxHeight: '879px',
            '> div': {
                flex: 1,
            }
        }
    }
    return (
        <Page
            seo={{
                title: 'Le Prive',
                description: SeoHelper.getDescription()
            }}
            hasNoIndex={false}
            hasNoFollow={false}
        >
            <Box className="leprive">
                <Container>
                    <Flex
                        as="section"
                        gap={{
                            base: '24px',
                            lg: '50px'
                        }}
                        my={{
                            base: '48px',
                            lg: '96px'
                        }}
                        flexDir={{
                            base: 'column'
                        }}
                        sx={{
                            background: '#fffdf5',
                            overflowY: 'hidden'
                        }}
                    >
                        <Box sx={style.grid} className="grid">
                             <ImageCms
                                 attributes={{
                                     width: 1528,
                                     height: 932,
                                     url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/644e8b7a-fded-4fa3-2bd2-d4cba793fe00/public',
                                 }}
                                 src={''}
                                 alt="banner1"
                                 className="image"
                                 style={style.img}
                             />
                        </Box>
                        <Box sx={style.grid} className="grid">
                            <GridItem colSpan={2}>
                                <Box sx={style.box} className="box">
                                    {
                                        locale === 'pl' ? (
                                            <p className={'paragraph'} style={style.paragraph}>
                                                Nasza walentynkowa niespodzianka! Zobaczcie wspólną selekcję walentynkową, którą przygotowałyśmy dla Was z marką LE PRIVÉ. Połączyły nas autorskie, ikoniczne wzory i możliwość tworzenia niepowtarzalnych kompozycji. Wiemy, że ubrania i biżuteria to idealny przepis na poprawę humoru, więc obejrzyjcie jak wystylizowałyśmy te dwie, romantyczne selekcje.
                                            </p>
                                        ) : (
                                            <p className={'paragraph'} style={style.paragraph}>
                                                Notre surprise pour la Saint-Valentin ! Découvrez la sélection exclusive que nous avons préparée pour cette occasion spéciale, avec la marque LE PRIVÉ.
                                                Nous avons été unis par des motifs originaux et emblématiques, ainsi que par notre passion commune pour la création de compositions uniques.
                                                Nous savons que les vêtements et les bijoux ont le pouvoir d’embellir votre quotidien et d&#39;améliorer votre humeur, alors découvrez comment nous avons conçu ces deux sélections romantiques.
                                            </p>
                                        )
                                    }
                                    <Box sx={style.button}
                                         className="button"
                                         onClick={() => history.push(locale === 'pl' ? 'https://leprive.pl/pl/menu/v-day-263.html?utm_source=lilou&utm_medium=referral&utm_campaign=lilou_leprive_012025_redirect' : 'https://leprive.eu/fr/menu/v-day-263.html?utm_source=lilou&utm_medium=referral&utm_campaign=lilou_leprive_012025_redirect')}>
                                        {
                                            locale === 'pl' ? (
                                                'Odkryj kolekcję LE PRIVÉ'
                                            ) : (
                                                'Découvrez la collection LE PRIVÉ'
                                            )
                                        }
                                    </Box>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={2}>
                                <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 742,
                                        url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/8c5a39fb-6c76-4b90-5c73-8308ed09c600/public'
                                    }}
                                    src={''}
                                    alt="banner2"
                                    className="image"
                                    style={style.img}
                                />
                            </GridItem>
                        </Box>
                        <Box sx={style.grid} className="grid">
                            <GridItem colSpan={2}>
                                <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 742,
                                        url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/80ffc707-a407-4f8e-5237-b2d75210ad00/public'
                                    }}
                                    src={''}
                                    alt="banner3"
                                    className="image"
                                    style={style.img}
                                />
                            </GridItem>
                            <GridItem colSpan={2}>
                                <Box sx={style.box} className="box boxSmall">
                                    <Box sx={style.button} className="button" onClick={() => history.push(locale === 'pl' ? 'https://lilou.pl/pl/sklep/polecane/inspiracje/lilou-x-le-prive.html' : 'https://lilou.fr/fr/shop/recommandes/inspirations/lilou-x-le-prive.html')}>
                                        {
                                            locale === 'pl' ? (
                                                'Odkryj selekcję Lilou'
                                            ) : (
                                                'Découvrez la sélection Lilou'
                                            )
                                        }
                                    </Box>
                                </Box>
                            </GridItem>
                        </Box>
                        <Box sx={style.grid} className="grid">
                            <GridItem colSpan={2}>
                                <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 742,
                                        url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/ae0b52cd-b258-49a6-0e70-180457710c00/public'
                                    }}
                                    src={''}
                                    alt="banner3"
                                    className="image"
                                    style={style.img}
                                />
                            </GridItem>
                            <GridItem colSpan={2}>
                                <Box sx={style.box} className="box">
                                    <ImageCms
                                        attributes={{
                                            height: 932,
                                            width: 932,
                                            url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/870d5e48-8bbf-408f-52c3-55b26f325900/public',
                                        }}
                                        src={''}
                                        alt="banner4"
                                        className={'imgRightAbsolute'}
                                        style={style.imgRightAbsolute}
                                    />
                                    <Box sx={style.heading}>
                                        {
                                            locale === 'pl' ? (
                                                'KLASYCZNIE'
                                            ) : (
                                                'CLASSIQUE'
                                            )
                                        }
                                        <br/>
                                        {
                                            locale === 'pl' ? (
                                                'One Night In Paris Dress'
                                            ) : (
                                                'One Night In Paris Dress'
                                            )
                                        }
                                        <br/>
                                        +<br/>
                                        {
                                            locale === 'pl' ? (
                                                'Naszyjnik Icons z czerwonym kryształem'
                                            ) : (
                                                'Collier Icons avec cristal rouge'
                                            )
                                        }
                                        <br/>
                                    </Box>
                                </Box>
                            </GridItem>
                        </Box>
                        <Box sx={style.grid} className="grid-reverse">
                            <GridItem colSpan={2}>
                                <Box sx={style.box} className="box boxBig">
                                    <ImageCms
                                        attributes={{
                                            height: 932,
                                            width: 932,
                                            url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/800cdde5-5232-40ed-e685-ca704a445c00/public',
                                        }}
                                        src={''}
                                        alt="banner6"
                                        className={'imgLeftAbsolute'}
                                        style={style.imgLeftAbsolute}
                                    />
                                    <ImageCms
                                        attributes={{
                                            height: 932,
                                            width: 932,
                                            url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/d40a2a7b-72d0-4ce7-3b2d-f9679a960700/public',
                                        }}
                                        src={''}
                                        alt="banner6"
                                        className={'imgLeftAbsoluteBottom'}
                                        style={style.imgLeftAbsoluteBottom}
                                    />
                                    <Box sx={style.heading}>
                                        HOT<br/>
                                        <br/>
                                        Burning Desire Corset<br/>
                                        +<br/>
                                        {
                                            locale === 'pl' ? (
                                                'Naszyjnik z puzderkiem'
                                            ) : (
                                                'Collier avec pendentif Coeur ouvrant'
                                            )
                                        }
                                        <br/>
                                    </Box>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={2}>
                                <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 621,
                                        url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/5089e09c-f2a7-4415-7ad2-96138fa0aa00/public',
                                    }}
                                    src={''}
                                    alt="banner7"
                                    className="image"
                                    style={style.img}
                                />
                            </GridItem>
                        </Box>
                        <Box sx={style.grid} className="grid">
                            <GridItem colSpan={2}>
                                <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 620,
                                        url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/c24d3f57-609d-4b59-2a4e-d5575a604500/public',
                                    }}
                                    src={''}
                                    className={'banner10 image'}
                                    alt="banner10"
                                    style={style.img}
                                />
                            </GridItem>
                            <GridItem colSpan={2}>
                               <Box sx={style.box} className="box">
                                   <ImageCms
                                       attributes={{
                                           height: 932,
                                           width: 932,
                                           url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/12edb170-b4be-486e-0722-0d6457e1ab00/public',
                                       }}
                                       src={''}
                                       alt="banner9"
                                       className={'imgRightAbsolute'}
                                       style={style.imgRightAbsolute}
                                   />
                                   <Box sx={style.heading}>
                                       {
                                           locale === 'pl' ? (
                                               'UROCZO'
                                           ) : (
                                               'MIGNON'
                                           )
                                       }
                                       <br/>
                                       <br/>
                                       Sugar Crush Dress<br/>
                                       +<br/>
                                       {
                                           locale === 'pl' ? (
                                               'Naszyjnik z puzderkiem'
                                           ) : (
                                               'Collier chaîne Cube et pendentif coeur ouvrant '
                                           )
                                       }
                                       <br/>
                                   </Box>
                               </Box>
                            </GridItem>
                        </Box>
                        <Box sx={style.grid} className="grid">
                            <GridItem colSpan={12}>
                                <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 620,
                                        url: locale === 'pl' ? 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/c36d7c94-9b4f-4a9b-31cb-514404139600/public' : 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/07cb1681-9974-418b-2a11-f3090f872a00/public',
                                    }}
                                    src={''}
                                    alt="banner9"
                                    className="image"
                                    style={style.img}
                                />
                            </GridItem>
                        </Box>
                        <Box sx={style.grid} className="grid">
                            <GridItem colSpan={2}>
                                <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 620,
                                        url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/85949057-3fa9-4931-09f0-5f0ec370fd00/public',
                                    }}
                                    src={''}
                                    className={'banner12 image'}
                                    alt="banner12"
                                    style={style.img}
                                />
                            </GridItem>
                            <GridItem colSpan={2}>
                                <Box sx={style.box} className="box">
                                    {
                                        locale === 'pl' ? (
                                            <p className={'paragraphRightJustify'} style={style.paragraphRightJustify}>
                                                Biżuteria, która zachwyca i przyciąga spojrzenia powstała na bazie autorskich projektów. Wyjątkowa kolekcja Icons z czerwonym kryształem, naszyjniki z puzderkiem - idealny sposób, by mieć ukochaną osobę zawsze przy sobie oraz ażurowe kolczyki, delikatne łańcuszki z motywem koniczyny i lilli.
                                            </p>
                                        ) : (
                                            <p className={'paragraphRightJustify'} style={style.paragraphRightJustify}>
                                                Les bijoux qui captivent et attirent l’attention reposent sur des designs originaux. L&#39;unique collection Icons, avec son cristal rouge éclatant, les colliers ornés de pendentifs en forme de cœur ouvrant — le moyen idéal pour garder votre être cher près de vous — ainsi que des boucles d&#39;oreilles ajourées et des chaînes délicates, sublimées par des motifs de trèfle et de lys.
                                            </p>
                                        )
                                    }
                                    <br/><br/>
                                    {
                                        locale === 'pl' ? (
                                            <p className={'paragraphRightJustify'} style={style.paragraphRightJustify}>
                                                Prezentowana walentynkowa selekcja to efekt współpracy założycielek marek LE PRIVÉ i LILOU – Alex, Patrycji i Magdaleny. Połączyły swoje pasje i poczucie stylu, by stworzyć stylizacje, które uwodzą, inspirują i nie pozwalają o sobie zapomnieć.
                                            </p>
                                        ) : (
                                            <p className={'paragraphRightJustify'} style={style.paragraphRightJustify}>
                                                La sélection présentée pour la Saint-Valentin est le résultat de la collaboration entre les fondatrices des marques LE PRIVÉ et LILOU : Alex, Patrycja et Magdalena. Elles ont fusionné leurs passions et leur sens aigu du style pour créer des pièces qui séduisent, inspirent et marquent les esprits.
                                            </p>
                                        )
                                    }
                                </Box>
                            </GridItem>
                        </Box>
                        <Box sx={style.grid} className="grid">
                            <GridItem colSpan={12}>
                                <ImageCms
                                    attributes={{
                                        height: 893,
                                        width: 1850,
                                        url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/923268d9-f58f-454c-cb7d-ea51737c1b00/public',
                                    }}
                                    src={''}
                                    alt="banner13"
                                    className="image"
                                    style={style.img}
                                />
                            </GridItem>
                        </Box>
                        <Box sx={style.gridNoGap} className="grid">
                            <GridItem colSpan={2}>
                                <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 620,
                                        url: 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/d6ab47d4-87ed-419d-56a8-33a62a9f6300/public',
                                    }}
                                    src={''}
                                    alt="banner14"
                                    className="banner14 image imgDown"
                                    style={style.imgDown}
                                />
                            </GridItem>
                            <GridItem colSpan={2}>
                                 <ImageCms
                                    attributes={{
                                        height: 932,
                                        width: 620,
                                        url: 'https://lilouparis.com/media/landingpage/15.gif',
                                    }}
                                    src={''}
                                    alt="banner15"
                                    className="image imgDown"
                                    style={style.imgDown}
                                 />
                            </GridItem>
                        </Box>
                    </Flex>
                </Container>
            </Box>
        </Page>
    )
}

export default LePrive
